import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator }  from '@react-navigation/native-stack';
import { createBottomTabNavigator }    from '@react-navigation/bottom-tabs';
import { Text, View, ActivityIndicator } from 'react-native';

import { useAuth } from '../context/AuthContext';

// Screens
import LoginScreen          from '../screens/LoginScreen';
import RegisterScreen       from '../screens/RegisterScreen';
import HomeScreen           from '../screens/HomeScreen';
import SearchResultsScreen  from '../screens/SearchResultsScreen';
import VehicleDetailScreen  from '../screens/VehicleDetailScreen';
import MatchingScreen       from '../screens/MatchingScreen';
import BookingConfirmScreen from '../screens/BookingConfirmScreen';
import MyBookingsScreen     from '../screens/MyBookingsScreen';
import ProfileScreen        from '../screens/ProfileScreen';

const Stack = createNativeStackNavigator();
const Tab   = createBottomTabNavigator();

const COLORS = { primary: '#F5C518', dark: '#1a1a1a', gray: '#888' };

// ── Tab Navigator (usuário logado) ────────────────────────
function MainTabs() {
  return (
    <Tab.Navigator
      screenOptions={{
        headerShown: false,
        tabBarActiveTintColor: COLORS.primary,
        tabBarInactiveTintColor: COLORS.gray,
        tabBarStyle: { backgroundColor: '#fff', borderTopColor: '#eee', paddingBottom: 5, height: 60 },
        tabBarLabelStyle: { fontSize: 12, fontWeight: '600' },
      }}
    >
      <Tab.Screen
        name="Home"
        component={HomeScreen}
        options={{ tabBarLabel: 'Buscar', tabBarIcon: ({ color }) => <Text style={{ fontSize: 22, color }}>🔍</Text> }}
      />
      <Tab.Screen
        name="MyBookings"
        component={MyBookingsScreen}
        options={{ tabBarLabel: 'Reservas', tabBarIcon: ({ color }) => <Text style={{ fontSize: 22, color }}>📋</Text> }}
      />
      <Tab.Screen
        name="Profile"
        component={ProfileScreen}
        options={{ tabBarLabel: 'Perfil', tabBarIcon: ({ color }) => <Text style={{ fontSize: 22, color }}>👤</Text> }}
      />
    </Tab.Navigator>
  );
}

// ── Stack completo ────────────────────────────────────────
export default function AppNavigator() {
  const { isLoggedIn, loading } = useAuth();

  if (loading) {
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#F5C518' }}>
        <Text style={{ fontSize: 32, fontWeight: 'bold', color: '#1a1a1a', marginBottom: 16 }}>YBR</Text>
        <ActivityIndicator size="large" color="#1a1a1a" />
      </View>
    );
  }

  return (
    <NavigationContainer>
      <Stack.Navigator
        screenOptions={{
          headerStyle: { backgroundColor: '#F5C518' },
          headerTintColor: '#1a1a1a',
          headerTitleStyle: { fontWeight: 'bold' },
          headerBackTitle: 'Voltar',
        }}
      >
        {!isLoggedIn ? (
          // Rotas públicas
          <>
            <Stack.Screen name="Login"    component={LoginScreen}    options={{ headerShown: false }} />
            <Stack.Screen name="Register" component={RegisterScreen} options={{ title: 'Criar Conta' }} />
          </>
        ) : (
          // Rotas autenticadas
          <>
            <Stack.Screen name="Main"           component={MainTabs}            options={{ headerShown: false }} />
            <Stack.Screen name="SearchResults"  component={SearchResultsScreen}  options={{ title: 'Veículos Disponíveis' }} />
            <Stack.Screen name="VehicleDetail"  component={VehicleDetailScreen}  options={{ title: 'Detalhes do Veículo' }} />
            <Stack.Screen name="Matching"       component={MatchingScreen}       options={{ title: '🔗 Rotas Complementares' }} />
            <Stack.Screen name="BookingConfirm" component={BookingConfirmScreen} options={{ title: 'Confirmar Reserva' }} />
          </>
        )}
      </Stack.Navigator>
    </NavigationContainer>
  );
}
